import { defineStore } from 'pinia'
import { ref, reactive, computed } from 'vue'
import { useRouter } from 'vue-router'

import { useKeycloak } from '@/composables/useKeycloak'
import { apiUserInfo } from '@/services/user'
import { useAlert } from '@/composables/useAlert'
import { useStorage } from '@/composables/useStorage'
import { menuGlobal } from '@/utils/menuGeral'

import store from '@/store'

export const useUsuario = defineStore('usuario', () => {
  const { push } = useRouter()
  const { commit, dispatch } = store
  const { email, token, getUserInfo, setIdTokenParsed, setUserInfo, setKeycloakToken, getDelegacao, getLogout, deleteLogout } = useStorage()
  const { alertError, alertSucess, alertWarn } = useAlert()
  const { obter } = apiUserInfo()
  const { init } = useKeycloak()

  const loading = ref(false)
  const userInfo = ref(null)
  const permissao = ref(null)
  const menu = ref(null)

  const menuPrincipal = reactive(menuGlobal)

  const isAuthenticated = computed(() => !!userInfo.value)

  const obterUserInfoNc = async () => {
    try {
      loading.value = true
      const resposta = await obter()
      userInfo.value = resposta
      setUserInfo(userInfo.value)
    } catch (error) {
      alertError('Não foi possível carregar registro.')
    } finally {
      loading.value = false
    }
  }
  const obterUserInfoMain = async () => {
    try {
      loading.value = true
      const resposta = await obter()
      if (resposta === null || !resposta.ativo) {
        return await push('/nao-autorizado')
      } else {
        userInfo.value = resposta
        setUserInfo(userInfo.value)
        return await push('/home')
      }
    } catch (error) {
      alertError('Não foi possível carregar registro.')
    } finally {
      loading.value = false
    }
  }

  const authenticarContaKeycloak = async () => {
    userInfo.value = getUserInfo

    if (userInfo.value === null || userInfo.value === undefined) {
      loading.value = true

      if (window.location.href.indexOf('nao-autorizado') == -1 && email == null) {
        await init().finally(() => (loading.value = false))
      }
    }
  }

  const autorizar = async () => {
    if (userInfo.value != null && userInfo.value.ativo) {
      if (permissao.value) {
        await push('/nao-autorizado')
      }
    } else {
      await push('/nao-autorizado')
    }
    setUserInfo(userInfo.value)
  }

  const permitido = async (recurso) => {
    const usuario = getUserInfo
    let permissoes

    if (!usuario.grupos) return await push('/nao-autorizado')

    if (usuario.grupos[0].permissoes.indexOf('799-3') != -1) usuario.grupos[0].permissoes += ',799'

    if (usuario.grupos[0].permissoes.indexOf('792-3') != -1) usuario.grupos[0].permissoes += ',792'

    if (usuario.grupos[0].permissoes.indexOf('801-1-4') != -1) usuario.grupos[0].permissoes += ',801'

    if (usuario.grupos[0].permissoes.indexOf('802-1-4') != -1) usuario.grupos[0].permissoes += ',802'

    if (usuario.grupos[0].permissoes.indexOf('803-1-4') != -1) usuario.grupos[0].permissoes += ',803'

    if (usuario.grupos[0].permissoes.indexOf('804-1-4') != -1) usuario.grupos[0].permissoes += ',804'

    permissoes = usuario.grupos[0].permissoes
      .trim()
      .split(',')
      .find((element) => element == recurso)

    if (permissoes) {
      return true
    } else {
      return false
    }
  }

  const obterAcessos = async () => {
    const user = getUserInfo
    let menusGeral = menuPrincipal
    let menus = []
    let permissoes = []
    const delegacao = getDelegacao
    if (delegacao && delegacao != undefined) {
      let grupo = _.find(user.grupos, { gestorId: delegacao })

      if (grupo) {
        if (grupo.permissoes.indexOf('799-3') != -1) grupo.permissoes += ',799'

        if (grupo.permissoes.indexOf('792-3') != -1) grupo.permissoes += ',792'

        if (grupo.permissoes.indexOf('801-1-4') != -1) grupo.permissoes += ',801'

        if (grupo.permissoes.indexOf('802-1-4') != -1) grupo.permissoes += ',802'

        if (grupo.permissoes.indexOf('803-1-4') != -1) grupo.permissoes += ',803'

        if (grupo.permissoes.indexOf('804-1-4') != -1) grupo.permissoes += ',804'

        permissoes = grupo.permissoes.split(',')
      }
    }
    if (permissoes != null && permissoes.length == 0 && user != null && user.grupos != undefined && user.grupos != null) {
      if (user.grupos[0].permissoes.indexOf('799-3') != -1) user.grupos[0].permissoes += ',799'
      if (user.grupos[0].permissoes.indexOf('792-3') != -1) user.grupos[0].permissoes += ',792'
      if (user.grupos[0].permissoes.indexOf('801-1-4') != -1) user.grupos[0].permissoes += ',801'
      if (user.grupos[0].permissoes.indexOf('802-1-4') != -1) user.grupos[0].permissoes += ',802'
      if (user.grupos[0].permissoes.indexOf('803-1-4') != -1) user.grupos[0].permissoes += ',803'
      if (user.grupos[0].permissoes.indexOf('804-1-4') != -1) user.grupos[0].permissoes += ',804'
      permissoes = user.grupos[0].permissoes.split(',')
    }

    permissoes = _.sortBy(permissoes)

    for (const permissao of permissoes) {
      let parents = permissao.split('-')

      if (parents.length == 1) {
        let registro = _.find(menusGeral, { codigo: parents[0] })

        if (registro) {
          let registroExiste = _.find(menus, { codigo: registro.codigo })

          if (!registroExiste) menus.push(registro)
        }
      }

      if (parents.length == 2) {
        let pai = _.find(menusGeral, { codigo: parents[0] })

        if (pai && pai.itens) {
          let itemMenu = _.find(pai.itens, { codigo: permissao })

          if (itemMenu) {
            let paiExiste = _.find(menus, { codigo: pai.codigo })

            if (!paiExiste) {
              let paiMenu = JSON.parse(JSON.stringify(pai))
              paiMenu.itens = []
              paiMenu.itens.push(itemMenu)
              menus.push(paiMenu)
            } else {
              let itemExiste = _.find(paiExiste.itens, {
                codigo: itemMenu.codigo
              })

              if (!itemExiste) {
                paiExiste.itens.push(itemMenu)
              }
            }
          }
        }
      }

      if (parents.length == 3) {
        let avo = _.find(menusGeral, { codigo: parents[0] })

        if (avo) {
          let pai = _.find(avo.itens, {
            codigo: `${parents[0]}-${parents[1]}`
          })

          if (pai) {
            let avoExiste = _.find(menus, { codigo: avo.codigo })

            if (!avoExiste) {
              let AvoMenu = JSON.parse(JSON.stringify(avo))
              AvoMenu.itens = []
              AvoMenu.itens.push(pai)
              menus.push(AvoMenu)
            } else {
              let paiExiste = _.find(avoExiste.itens, { codigo: pai.codigo })
              if (!paiExiste) {
                avoExiste.itens.push(pai)
              }
            }
          }
        }
      }
    }

    menus = _.sortBy(menus, [
      function (o) {
        return o.descricao
      }
    ])

    menu.value = menus
    await carregarInfo()
  }

  const carregarInfo = async () => {
    const userInfo = getUserInfo
    if (userInfo != undefined) {
      let dados = {
        logotipo: 'https://cdn1.lg.com.br/autoatendimento/3.1.0/img/logotipo.png',
        nomePortal: `Categoria C ${process.env.VUE_APP_VERSAO} ${process.env.VUE_APP_AMBIENTE != 'PROD' ? ' - ' + process.env.VUE_APP_AMBIENTE : ''}`,
        usuario: {
          nome: userInfo.nome.toUpperCase(),
          foto: 'https://as2.ftcdn.net/jpg/03/46/93/61/220_F_346936114_RaxE6OQogebgAWTalE1myseY1Hbb5qPM.jpg',
          cargo: `(${userInfo.cargo.codigo}) ${userInfo.cargo.descricao.toUpperCase()}`,
          menus: [
            {
              codigo: '99999',
              descricao: 'Sair',
              icone: 'fa fa-sign-out',
              url: '/home',
              uid: 1893484233,
              acao: 4
            }
          ]
        },
        menus: []
      }

      dados.menus = menu.value

      commit('layout/setDadosLayout', dados)
      dispatch('user/getUser', userInfo)
    }
  }

  return {
    loading,
    userInfo,
    permissao,
    menu,
    menuPrincipal,
    isAuthenticated,
    obterUserInfoNc,
    obterUserInfoMain,
    authenticarContaKeycloak,
    autorizar,
    permitido,
    obterAcessos,
    carregarInfo
  }
})
